import { ActionTree } from 'vuex';
import { MyDeviceState } from './MyDeviceTypes';
import { RootState } from '@/app/shared/store/RootState';

export const actions: ActionTree<MyDeviceState, RootState> = {

};
